import React from "react";
import { motion } from "framer-motion";
import fuel from "../../assets/img/nick.jpg";
import oxiswap from "../../assets/img/l22.png";
import yuri from "../../assets/img/yuri.jpg";
import qoodo from "../../assets/img/qoodo.jpg";
import axir from "../../assets/img/axir.jpg";
import Antoine from "../../assets/img/antoine.jpg";
import griffy from "../../assets/img/griffy.jpg";
import vish from "../../assets/img/vish.jpg";
import arjun from "../../assets/img/arjun.jpg";
import logo from "../../assets/img/stork.png";
import logo2 from "../../assets/img/hyperlane.png";

const testimonials = [
  {
    author: "Nick Dodson",
    role: "Founder, Fuel Network",
    quote: "Safe Edges helped us perform efficient and timely audits across the Fuel ecosystem. Their deep expertise in Sway and Fuel has made them a serious player in the auditing space.",
    image: fuel,
    featured: true,
  },
  {
    author: "Arjun Kalsy",
    role: "Chief of Growth, Fuel Network",
    quote: "Safe Edges is one of the best auditors we have worked with so far.",
    image: arjun,
  },
  {
    author: "Hyperlane",
    role: "Hyperlane Protocol",
    quote: "We very much appreciate Safe Edges' approach to security and the entire audit process.",
    image: logo2,
  },
  {
    author: "Ruscet",
    role: "Founder, Ruscet",
    quote: "10/10. They are hands down some of the absolute best security minds in the space.",
    image: Antoine,
  },
  {
    author: "Yuri",
    role: "Co-founder, Swaylend",
    quote: "Experience was truly awesome. Safe Edges showed a high level of sincerity, going through every single line of code with us on our kickoff call.",
    image: yuri,
  },
  {
    author: "Gabor Kiss",
    role: "Co-founder, Qoodo",
    quote: "Safe Edges demonstrates professionalism and attention to detail second to none.",
    image: qoodo,
  },
  {
    author: "VishNft",
    role: "Co-founder, Lync World",
    quote: "Safe Edges is one of the best auditors we have worked with so far.",
    image: vish,
  },
  {
    author: "Oswald",
    role: "Founder, Griffy Market",
    quote: "Impressive work by Safe Edges. Highly recommend their services!",
    image: griffy,
  },
  {
    author: "Stork Network",
    role: "Stork Protocol",
    quote: "Experience was truly awesome. Safe Edges showed a high level of sincerity from the jump.",
    image: logo,
  },
];

const StarRow = () => (
  <div className="flex gap-0.5 mb-3">
    {[...Array(5)].map((_, i) => (
      <svg key={i} width="12" height="12" viewBox="0 0 24 24" fill="#00A99E" aria-hidden="true">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);

const fade = (i) => ({
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1, y: 0,
    transition: { duration: 0.55, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }
  }
});

const MapToSafety = () => {
  const featured = testimonials.find(t => t.featured);
  const rest = testimonials.filter(t => !t.featured);

  return (
    <section className="py-28 bg-black relative overflow-hidden">

      {/* Top rule */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-px bg-gradient-to-r from-transparent via-[#00A99E]/30 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="text-xs tracking-[0.25em] uppercase text-[#00A99E] mb-4">Client Reviews</p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              Trusted by builders<br />
              <span
                className="text-transparent bg-clip-text"
                style={{ backgroundImage: 'linear-gradient(90deg, #00A99E, #5ef0e4)' }}
              >
                across Web3.
              </span>
            </h2>
            <p className="text-sm text-gray-500 max-w-xs md:text-right">
              200+ projects have trusted Safe Edges to secure their smart contracts and protocols.
            </p>
          </div>
        </motion.div>

        {/* Grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

          {/* Featured — spans 2 rows */}
          {featured && (
            <motion.div
              variants={fade(0)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="md:row-span-2 border border-white/10 rounded-2xl p-7 bg-gradient-to-br from-[#00A99E]/8 to-transparent flex flex-col justify-between hover:border-[#00A99E]/30 transition-colors duration-300"
            >
              <div>
                <StarRow />
                <blockquote className="text-white text-lg font-medium leading-relaxed mb-8">
                  "{featured.quote}"
                </blockquote>
              </div>
              <div className="flex items-center gap-3">
                <img
                  src={featured.image}
                  alt={featured.author}
                  width={44}
                  height={44}
                  className="w-11 h-11 rounded-full object-cover border border-white/10 flex-shrink-0"
                  onError={e => { e.target.style.display = 'none'; }}
                />
                <div>
                  <p className="text-white text-sm font-semibold">{featured.author}</p>
                  <p className="text-gray-500 text-xs">{featured.role}</p>
                </div>
              </div>
            </motion.div>
          )}

          {/* Remaining cards */}
          {rest.map((t, i) => (
            <motion.div
              key={i}
              variants={fade(i + 1)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="border border-white/8 rounded-2xl p-6 bg-white/[0.02] flex flex-col justify-between hover:border-white/15 hover:bg-white/[0.04] transition-all duration-300"
            >
              <div>
                <StarRow />
                <blockquote className="text-gray-300 text-sm leading-relaxed mb-5">
                  "{t.quote}"
                </blockquote>
              </div>
              <div className="flex items-center gap-3">
                <img
                  src={t.image}
                  alt={t.author}
                  width={36}
                  height={36}
                  className="w-9 h-9 rounded-full object-cover border border-white/10 flex-shrink-0"
                  onError={e => { e.target.style.display = 'none'; }}
                />
                <div>
                  <p className="text-white text-sm font-medium">{t.author}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default MapToSafety;
